import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Icon } from '@panel/commons';
import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  min-height: 214px;
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  background-color: ${select('white')};
  flex-flow: column nowrap;
  border-radius: 8px;
  padding: 40px;
  font-family: 'Hind';
  align-items: center;
  box-sizing: border-box;
  position: relative;
  > div.iconWrapper {
    position: absolute;
    &:hover {
      cursor: pointer;
    }
    top: 22px;
    right: 22px;
  }
  > h4 {
    font-size: 20px;
    line-height: 26px;
    ${withQuery.md.down()} {
      margin-top: 15px;
    }
  }
  > div.message {
    max-width: 100%;
    font-size: 16px;
    line-height: 25px;
    color: ${select('darkGray')};
    margin: 5px auto 20px;
    white-space: break-spaces;
    text-align: center;
    ${withQuery.md.down()} {
      margin-bottom: 30px;
      white-space: initial;
      text-align: center;
    }
  }
  ${withQuery.md.down()} {
    max-width: 96vw;
    margin: 0 auto;
    margin-top: 35vh;
  }
`;

const CTAButton = styled.button`
  display: block;
  margin: 0 auto;
  width: 176px;
  height: 48px;
  padding: 13px 15px;
  background: ${getColor('primary')};
  border-radius: 12px;
  color: ${select('white')};
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  border-radius: 12px;
  &:hover {
    cursor: pointer;
  }
`;

function BlockedModal({ onClose, error, blockedUserMessageKey }) {
  const { t } = useTranslation();

  const title = blockedUserMessageKey
    ? t(`${blockedUserMessageKey}.title`)
    : t('publisher.form.convertseeker.error.title');
  const message = blockedUserMessageKey ? t(blockedUserMessageKey) : t('publisher.form.convertseeker.error.subtitle');
  const btnText = blockedUserMessageKey
    ? t(`${blockedUserMessageKey}.button`)
    : t('publisher.modal.disabledBranch.button');

  return (
    <Container data-repa='blockedUser-container'>
      <div
        data-repa='blockedUser-iconWrapper'
        className='iconWrapper'
        role='button'
        tabIndex='0'
        aria-hidden='true'
        onClick={onClose}
      >
        <Icon name='close' colorFill='black' data-repa='blockedUser-icon' />
      </div>
      <h4 data-repa='blockedUser-title'>{title}</h4>
      <div className='message' data-repa='blockedUser-msg'>
        {message}
      </div>
      <CTAButton data-repa='blockedUser-CTA' onClick={onClose}>
        {btnText}
      </CTAButton>
    </Container>
  );
}

export { BlockedModal };
